import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import CheckBox from '../../Content/Elements/CheckBox/CheckBox';
import Button from '../../Input/Button/Button';
import TextArea from '../../Input/TextArea/TextArea';
import './CommentInput.scss';

export default class CommentInput extends React.Component {
    constructor(props) {
        super();

        this.state = {
            showHiddenComponents: props.hiddenComponentsDefault,
            comment: null,
            label:
                props && props.label
                    ? props.label
                    : 'Check to share anonymously',
            isAnonymous: props.defaultIsAnonymous,
            textAreaError: '',
        };
    }

    static propTypes = {
        /**
         * prop for default anonymous or not anonymous: default false
         */
        defaultIsAnonymous: PropTypes.bool,
        /**
         * prop for what you want button text to say
         */
        buttonText: PropTypes.string,
        parentHash: PropTypes.string,
        onSubmit: PropTypes.func,
        placeholderText: PropTypes.string,
        hiddenComponentsDefault: PropTypes.bool,
        label: PropTypes.string,
        /**
         * default comment sent in for editing comment
         */
        comment: PropTypes.object,
        /**
         * context function for clearing active comment hash if cancel is clicked
         */
        setEditingCommentHash: PropTypes.func,
        /**
         * context function for publishing comment edits
         */
        onPublishComment: PropTypes.func,
        /**
         * string text for secondary button, e.g. cancel
         */
        secondaryButtonText: PropTypes.string,
        /**
         * toggle label with user input changes
         */
        allowLabelOverride: PropTypes.bool,
    };

    static defaultProps = {
        defaultIsAnonymous: false,
        buttonText: 'Post comment',
        onSubmit: () => {},
        placeholderText: 'Join the conversation...',
        hiddenComponentsDefault: false,
        comment: null,
        secondaryButtonText: 'Cancel',
        allowLabelOverride: true,
    };

    static getDerivedStateFromProps(props, state) {
        if (props.comment && !state.comment) {
            return {
                comment: props.comment,
                showHiddenComponents: true,
            };
        }

        return null;
    }

    componentDidMount() {
        this.props.comment && this.props.comment.length
            ? this.getLineNumber()
            : null;
    }

    handleOnChange = (comment) => {
        const showHidden = comment.length > 0 || false;
        this.setState({
            showHiddenComponents: showHidden,
            comment: comment,
        });
        this.getLineNumber();
    };

    handleCheckOnChange = (value) => {
        const { allowLabelOverride } = this.props;
        const label =
            value === true ? 'Anonymous' : 'Check to share anonymously';
        const isAnonymous = value;

        const updates = { isAnonymous };

        if (allowLabelOverride) {
            updates.label = label;
        }

        this.setState(updates);
    };

    pressedSubmit = (e) => {
        this.props.onSubmit(
            this.props.parentHash,
            this.state.comment,
            this.state.isAnonymous
        );
        this.commentInputRef.value = '';
        this.commentInputRef.setAttribute('style', 'height:auto;');
        this.setState({
            showHiddenComponents: false,
            comment: null,
            isAnonymous: false,
        });
    };

    getCommentInputRef = (node) => {
        this.commentInputRef = node;
    };

    getLineNumber = () => {
        if (!this.commentInputRef) {
            return;
        }
        let commentInputRef = this.commentInputRef;
        commentInputRef.setAttribute(
            'style',
            `height: ${commentInputRef.scrollHeight}px; max-height: 200px`
        );
    };

    renderAnonymousCheckBox = () => {
        const { parentHash } = this.props;
        const { isAnonymous, label } = this.state;
        return (
            <CheckBox
                id={`anon-checkbox-${parentHash}-child`}
                defaultChecked={isAnonymous}
                handleChange={this.handleCheckOnChange}
                label={label}
            />
        );
    };

    renderActionButtons = () => {
        return (
            <div className="buttonDiv">
                {this.props.comment && (
                    <Button
                        value={this.props.secondaryButtonText}
                        type="tertiary-blue-gray"
                        class="cancel"
                        onClick={this.props.onCancel}
                    />
                )}
                <Button
                    onClick={(e) => this.pressedSubmit(e)}
                    type={'solid'}
                    class="submit"
                    value={this.props.buttonText}
                />
            </div>
        );
    };

    renderCommentInput = () => {
        const showHidden = !this.state.showHiddenComponents
            ? 'hidden'
            : 'active';
        const isActiveStyles = !this.state.showHiddenComponents
            ? ''
            : 'isActive';

        return (
            <div className="component-Content-Sections-ReactionBar-CommentInput">
                <span className={isActiveStyles}>
                    <TextArea
                        type={'textarea'}
                        name={'commentInput'}
                        placeholder={this.props.placeholderText}
                        onChange={this.handleOnChange}
                        value={this.state.comment}
                        rows={1}
                        refs={this.getCommentInputRef}
                    />
                    <span className="error">{this.state.error}</span>
                </span>
                <div className={`${showHidden} submissionRow`}>
                    {this.renderAnonymousCheckBox()}
                    {this.renderActionButtons()}
                </div>
            </div>
        );
    };

    render() {
        let hashKey = 'input-' + this.props.parentHash;

        return (
            <PageConsumer>
                {(context) =>
                    context.wrapAuth(hashKey, this.renderCommentInput(), {
                        login_trigger: 'comment',
                    })
                }
            </PageConsumer>
        );
    }
}
